import { render, staticRenderFns } from "./UWorkflowStateIcons.vue?vue&type=template&id=23a80e01"
import script from "./UWorkflowStateIcons.vue?vue&type=script&lang=js"
export * from "./UWorkflowStateIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports